import styles from './CompanyDataForAiAgentsPage.module.scss';

import { CompanyDataCompare } from './sections/CompanyDataCompare/CompanyDataCompare';
import { CompanyDataCta } from './sections/CompanyDataCta/CompanyDataCta';
import { CompanyDataDelivery } from './sections/CompanyDataDelivery/CompanyDataDelivery';
import { CompanyDataFaq } from './sections/CompanyDataFaq/CompanyDataFaq';
import { CompanyDataHero } from './sections/CompanyDataHero/CompanyDataHero';
import { CompanyDataPipeline } from './sections/CompanyDataPipeline/CompanyDataPipeline';
import { CompanyDataProvenance } from './sections/CompanyDataProvenance/CompanyDataProvenance';
import { CompanyDataRegis } from './sections/CompanyDataRegis/CompanyDataRegis';
import { CompanyDataStatement } from './sections/CompanyDataStatement/CompanyDataStatement';
import { CompanyDataWorkflows } from './sections/CompanyDataWorkflows/CompanyDataWorkflows';

export const CompanyDataForAiAgentsPage = () => (
  <div className={styles.wrapper}>
    <CompanyDataHero />
    <CompanyDataStatement />
    <CompanyDataPipeline />
    <CompanyDataDelivery />
    <CompanyDataProvenance />
    <CompanyDataRegis />
    <CompanyDataCompare />
    <CompanyDataWorkflows />
    <CompanyDataCta />
    <CompanyDataFaq />
  </div>
);
